export default "__VITE_ASSET__BGkQ8zn9__"